import React from "react";
import { SegmentedControl as SegmentedControlWrapper, Segment } from "./styles";
import { SegmentedControlProps } from "./types";

export const SegmentedControl: React.FC<SegmentedControlProps> = ({
  options,
  selectedValue,
  onChange,
  disabled,
}) => {
  return (
    <SegmentedControlWrapper role="group">
      {options.map((option) => (
        <Segment
          key={option.value}
          type="button"
          $active={option.value === selectedValue}
          aria-pressed={option.value === selectedValue}
          disabled={disabled}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </Segment>
      ))}
    </SegmentedControlWrapper>
  );
};
